export default __webpack_public_path__ + "static/media/Telugu_bm_1.dc7eb56f.mp3";